import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import React from 'react';
import {Fragment} from 'react';
import styled from 'styled-components';

import {Product, ProductToText} from '../data/product';

import {pxToEm} from './globalStyles';
import WrapperAppUl, {wrapperAppUlFonSizePx} from './wrapperAppUl';

//#region Styled Components

const StyledH2 = styled.h2`
  font-size: ${pxToEm(24)}em;
  color: ${baseVariables.colors.midnight};
  display: inline-block;
  margin: 0;
`;

const StyledContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 50%;
`;

const StyledTwoColumnsSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;

  > ${StyledContentColumn} {
    flex: 1 1 50%;

    :nth-child(1) {
      border-right: 2px solid ${baseVariables.colors.darkBlueGray};
      padding-right: 5%;
    }

    :nth-child(2) {
      padding-left: 5%;
    }
  }
  padding: ${pxToEm(47)}em 0 ${pxToEm(68)}em;
`;

const StyledListH3 = styled.h3`
  font-size: ${pxToEm(22) / pxToEm(wrapperAppUlFonSizePx)}em;
  color: ${baseVariables.colors.midnight};
  display: inline-block;
  margin: 0;
`;

const StyledListDiv = styled.div`
  margin-bottom: ${pxToEm(20)}em;
`;

//#endregion

interface BulletPoint {
  headline: string;
  description: string;
}

interface Props {
  product: Product;
  leftBulletPoints: BulletPoint[];
  rightBulletPoints: BulletPoint[];
}

const WhyBitmovinProductSection: React.FunctionComponent<Props> = ({product, leftBulletPoints, rightBulletPoints}) => {
  return (
    <Fragment>
      <StyledH2>{`Why Bitmovin ${ProductToText[product]}?`}</StyledH2>
      <StyledTwoColumnsSection>
        <StyledContentColumn>
          <WrapperAppUl>
            {leftBulletPoints.map((bulletPoint, index) => (
              <li key={`left-bullet-point-${index}`}>
                <StyledListH3>{bulletPoint.headline}</StyledListH3>
                <StyledListDiv>{bulletPoint.description}</StyledListDiv>
              </li>
            ))}
          </WrapperAppUl>
        </StyledContentColumn>
        <StyledContentColumn>
          <WrapperAppUl>
            {rightBulletPoints.map((bulletPoint, index) => (
              <li key={`right-bullet-point-${index}`}>
                <StyledListH3>{bulletPoint.headline}</StyledListH3>
                <StyledListDiv>{bulletPoint.description}</StyledListDiv>
              </li>
            ))}
          </WrapperAppUl>
        </StyledContentColumn>
      </StyledTwoColumnsSection>
    </Fragment>
  );
};

export default WhyBitmovinProductSection;
